import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { IProgram } from '@/types/program';
  import { reactive, inject, nextTick, ref } from 'vue';
  import _ from 'lodash';
  import { useRouter } from 'vue-router';
  import { authStore } from '@/stores';
  import { ColorVariants } from '@/constants';
  import Participate from './participate.vue';
  import Apply from './apply.vue';
  import { goToLogin } from '@/utils';

  interface IProps {
    program: IProgram;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram;
  }

  const router = useRouter();
  
  const participateRef = ref();
  const applyRef = ref();
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;

  const dialog = reactive({
    login: false,
    email: false,
    address: false,
    info: false,
  });

  const dialogTipMessage = ref('');

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
  }

  function showTipDialog(message: string) {
    dialogTipMessage.value = message;
    showDialog('info');
  };

  function login() {
    closeDialog();
    goToLogin();
  }

  function verify() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
  };

  function navToProfileEdit() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit' });
  };

  const check = async () => {
    if (!authStore.isLogin) {
      showDialog('login');
      return false;
    }
    await authStore.tryFetchData();
    const emailVerified = _.get(authStore, 'user.profile.email_verified');
    if (!emailVerified) {
      showDialog('email');
      return false;
    }
    if (!authStore.canParticipateProgram) {
      showDialog('address');
      return false;
    }
    return true;
  };

  // 1 检查collection次数
  // 2 检查show_collection_btn 为false则显示collection_btn_msg提示
  // 3 弹窗确认轮次
  // 4 点弹窗apply 执行apply
  const apply = async () => {
    const canApply = await check();
    if (canApply) {
      await refreshPageData();
      await nextTick();
      const { show_collection_btn, collection_btn_msg, collection_count, limit_collection_count } = props.program;
      // 如果limit_collection_count是null 表示不限制次数
      if (limit_collection_count) {
        // 没有次数了跳转到record
        if (collection_count >= limit_collection_count) {
          closeDialog();
          router.push({ name: 'mine.programParticipationDetail', params: { id: props.program.participation_request_id } });
          return;
        }
      }
      if (show_collection_btn) {
        applyRef.value.start();
      } else {
        showTipDialog(collection_btn_msg as string);
      }
    }
  };

  const participate = async () => {
    const canParticipate = await check();
    if (canParticipate) {
      await refreshPageData();
      await nextTick();
      const { show_participate_btn, participate_btn_msg } = props.program;
      if (show_participate_btn) {
        participateRef.value.start();
      } else {
        showTipDialog(participate_btn_msg as string);
      }
    }
  };


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).login,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).login) = $event)),
        class: "dialog-coca-cola",
        btns: [
        { text: '로그인', style: _unref(ColorVariants).dark, click: login }
      ],
        title: "원더플 피플!",
        content: "로그인 해주세요"
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).email,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).email) = $event)),
        class: "dialog-coca-cola",
        btns: [
        { text: '이메일 인증하기', style: _unref(ColorVariants).dark, click: verify }
      ],
        title: "원더플 피플!",
        content: "이메일 인증이 필요합니다."
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).address,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).address) = $event)),
        class: "dialog-coca-cola",
        btns: [
        { text: '확인', style: _unref(ColorVariants).dark, click: navToProfileEdit }
      ],
        title: "원더플 피플!",
        content: "마이페이지에서 주소 및 휴대폰 번호를 확인해주세요"
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).info) = $event)),
        class: "dialog-coca-cola",
        btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ],
        title: "원더플 피플!",
        content: dialogTipMessage.value
      }, null, 8, ["visible", "btns", "content"])
    ])),
    _createVNode(Participate, {
      ref_key: "participateRef",
      ref: participateRef,
      program: __props.program
    }, null, 8, ["program"]),
    _createVNode(Apply, {
      ref_key: "applyRef",
      ref: applyRef,
      program: __props.program
    }, null, 8, ["program"]),
    _renderSlot(_ctx.$slots, "default", {
      apply: apply,
      participate: participate
    })
  ], 64))
}
}

})